import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import BarLoader from 'react-spinners/BarLoader'
import View from './View'

const useStyles = createUseStyles(theme => ({
  root: {
    width: 'inherit',
    flexDirection: 'column'
  },
  message: {
    justifyContent: 'center',
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '28px',
    color: theme.colors.primary,
    textAlign: 'center'
  },
  loader: {
    marginTop: '10px',
    marginBottom: '10px'
  }
}))


function Loader (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  return (
    <View className={styles.root}>
      <View className={styles.message}>{props.message}</View>
      <View className={styles.loader}>
        <BarLoader color={theme.colors.primary} width="100%" />
      </View>
    </View>
  )
}

export default Loader